module.exports = "/images/vendor/flag-icon-css/flags/4x3/gf.svg?38dfa23a36e1e72303eaa3dbbd9db11a";